import PropTypes from 'prop-types';

export default PropTypes.shape({
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      serviceClass: PropTypes.string,
      departureTime: PropTypes.string,
      origin: PropTypes.string,
      destination: PropTypes.string,
      numberOfPassengers: PropTypes.number
    })
  ),
  reference: PropTypes.string,
  date: PropTypes.string
});
